<template>

  <div
    class="text-center"
    v-if="status.isBusy()"
  >
    <v-progress-circular indeterminate />
  </div>

  <v-alert
      v-if="status.isError()"
      color="error"
      icon="$error"
  >
    <template v-slot:text>
      {{ status.getError() }}
    </template>
  </v-alert>

  <template v-if="status.isReady()">
    <slot></slot>
  </template>

</template>

<script setup lang="ts">

import type { AsyncState } from '../utils/asyncStatus'

interface Props {
  status: AsyncState
}

defineProps<Props>()

</script>
